import React from 'react';

const Unauthorized = () => {
  return (
    <div className='bg-white h-100 w-100 p-md-5 p-3'>
      <div className='w-100 h-100 bg-light rounded d-flex flex-column align-items-center justify-content-center'>
        <h1 className='fw-bold'>401 - Unauthorized</h1>
        <hr className='bg-dark border-dark w-50' />
        <p className='fw-light'>Sorry, your request could not be processed</p>
      </div>
    </div>
  );
}

export default Unauthorized;
